import { useQuery } from "react-query";
import { getUserProjectRoles } from "../api/projectDetailsHttpClient";
import { UserProjectPermissions } from "../api/models/ProjectUserPermission";

export const projectUserPermissionsQueryKey = (projectId: string) =>
  ["user_project_permissions", projectId] as const;

const useProjectUserPermissions = (projectId: string) =>
  useQuery<UserProjectPermissions>(
    projectUserPermissionsQueryKey(projectId),
    () => getUserProjectRoles(projectId),
    {
      staleTime: Infinity,
      cacheTime: Infinity,
      refetchOnMount: false,
    }
  );

export default useProjectUserPermissions;